var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["modal/modal-close.j2"] = require( "modal/modal-close.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/site-message.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteMessage") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteMessage")),"message")) {
output += "\n\n    <div class=\"s-site-message is-shown dom-site-message has-error\">\n\n        <div class=\"c-form-block\">\n\n            <div class=\"o-row\">\n\n                <div class=\"o-column o-extra-small--11\">\n\n                        <div class=\"c-form-block__p\">\n                            ";
output += runtime.suppressValue((lineno = 11, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "errorTranslation"), "errorTranslation", context, ["ERROR_CORE_GENERAL_ERROR"])), env.opts.autoescape);
output += "\n                        </div>\n\n                </div>\n\n                <div class=\"o-column o-extra-small--1\">\n\n                        <div class=\"s-site-message__close\">\n\n                             <a class=\"s-site-message__close-link js-site-message__close-link\" href=\"\">\n\n                                ";
env.getTemplate("modal/modal-close.j2", false, "core/templates/header/site-message.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n                            </a>\n\n                        </div>\n\n                </div>\n\n            </div>\n\n        </div>\n\n    </div>\n\n";
})});
}
else {
output += "\n\n    <div class=\"s-site-message dom-site-message\"></div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/site-message.j2"] , dependencies)